// @flow strict

import {createContext} from 'react';

// $FlowFixMe[signature-verification-failure]
const I18nContext = createContext({labelI18nInstance: {}});
export default I18nContext;
